<template>
<div class="chapter">
<div class="inner_page">
<div id="lo">
<div class="generated-style">
<p class="gb">To George Landon, who didn’t teach me <span class="bold6">how</span> to write so much as <span class="bold6">why</span>.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LO-06.vue?39a6b0b5